import { useState, useEffect } from 'react';

const PHONE = '561-445-3948';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navLinks = [
    { label: 'Services', href: '#services' },
    { label: 'Results', href: '#results' },
    { label: 'Why Us', href: '#why-us' },
    { label: 'Reviews', href: '#reviews' },
    { label: 'Contact', href: '#contact' },
  ];

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-white border-b border-gray-200' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 lg:h-20">
            {/* Logo */}
            <a href="#hero" className="flex items-center gap-2 cursor-pointer">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-teal-600">
                <i className="ri-water-flash-fill text-white text-xl"></i>
              </div>
              <div>
                <p className={`font-bold text-sm leading-tight ${scrolled ? 'text-slate-900' : 'text-white'}`}>
                  Total Residential
                </p>
                <p className={`text-xs leading-tight font-medium ${scrolled ? 'text-teal-600' : 'text-teal-300'}`}>
                  Solution Inc
                </p>
              </div>
            </a>

            {/* Desktop Nav Links */}
            <div className="hidden lg:flex items-center gap-7">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    scrolled ? 'text-slate-700 hover:text-teal-600' : 'text-white/90 hover:text-white'
                  }`}
                >
                  {link.label}
                </a>
              ))}
            </div>

            {/* Desktop CTA */}
            <div className="hidden lg:flex items-center gap-3">
              <a
                href={`tel:${PHONE}`}
                className={`flex items-center gap-2 text-sm font-semibold cursor-pointer whitespace-nowrap ${
                  scrolled ? 'text-slate-800' : 'text-white'
                }`}
              >
                <div className="w-7 h-7 flex items-center justify-center">
                  <i className="ri-phone-fill text-orange-500 text-lg"></i>
                </div>
                {PHONE}
              </a>
              <a
                href="#contact"
                className="bg-orange-500 hover:bg-orange-600 text-white text-sm font-bold px-5 py-2.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
              >
                Free Estimate
              </a>
            </div>

            {/* Mobile Menu Button */}
            <div className="lg:hidden flex items-center gap-3">
              <a
                href={`tel:${PHONE}`}
                className="w-10 h-10 flex items-center justify-center rounded-full bg-orange-500 cursor-pointer"
              >
                <i className="ri-phone-fill text-white text-lg"></i>
              </a>
              <button
                onClick={() => setMenuOpen(!menuOpen)}
                className={`w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer ${
                  scrolled ? 'text-slate-800' : 'text-white'
                }`}
              >
                <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="lg:hidden bg-white border-t border-gray-200">
            <div className="px-4 py-4 flex flex-col gap-1">
              {navLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="text-slate-700 font-medium py-3 px-3 rounded-lg hover:bg-gray-50 cursor-pointer block"
                >
                  {link.label}
                </a>
              ))}
              <div className="mt-2 pt-3 border-t border-gray-100">
                <a
                  href={`tel:${PHONE}`}
                  className="flex items-center gap-2 bg-teal-600 text-white font-bold py-3 px-4 rounded-lg mb-2 cursor-pointer"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-phone-fill text-base"></i>
                  </div>
                  Call {PHONE}
                </a>
                <a
                  href="#contact"
                  onClick={() => setMenuOpen(false)}
                  className="block bg-orange-500 text-white font-bold py-3 px-4 rounded-lg text-center cursor-pointer"
                >
                  Get Free Estimate
                </a>
              </div>
            </div>
          </div>
        )}
      </nav>

      {/* Sticky Mobile Call Button */}
      <a
        href={`tel:${PHONE}`}
        className="lg:hidden fixed bottom-6 right-5 z-50 w-14 h-14 flex items-center justify-center bg-orange-500 rounded-full cursor-pointer"
        aria-label="Call us now"
      >
        <i className="ri-phone-fill text-white text-2xl"></i>
      </a>
    </>
  );
}
